export const CONSUMER_TABLE_CLASS = 'min-w-full border-collapse';

export const CONSUMER_THEAD_CLASS = 'bg-subtle sticky top-0 z-10';

export const CONSUMER_TBODY_CLASS = 'bg-card divide-y divide-line';

export const CONSUMER_TH_CLASS =
  'px-5 py-3 text-left text-[10px] font-bold text-muted uppercase tracking-widest border-r border-line last:border-r-0 bg-subtle whitespace-nowrap';

export const CONSUMER_TD_CLASS =
  'px-5 py-3.5 align-middle border-r border-line last:border-r-0';

export const CONSUMER_TH_NO_CLASS = `${CONSUMER_TH_CLASS} w-14 text-center`;
export const CONSUMER_TD_NO_CLASS = `${CONSUMER_TD_CLASS} whitespace-nowrap text-center text-sm font-medium text-muted tabular-nums`;

export const CONSUMER_CELL_TEXT = 'text-sm text-body';
export const CONSUMER_CELL_HEADING = 'text-sm font-semibold text-heading';
export const CONSUMER_CELL_MUTED = 'text-sm text-muted';
export const CONSUMER_CELL_LINK = 'text-sm font-semibold text-indigo-600 hover:underline';
export const CONSUMER_CELL_MONO = 'text-sm font-mono text-body whitespace-nowrap';

export const CONSUMER_TH_ACTION_CLASS = `${CONSUMER_TH_CLASS} w-24`;

export const CONSUMER_EYE_BTN_CLASS =
  'inline-flex items-center justify-center p-2 bg-indigo-500/10 hover:bg-indigo-500/15 text-indigo-700 border border-indigo-200/60 rounded-lg transition-all';

export function consumerRowNumber(page: number, index: number, limit: number) {
  return (page - 1) * limit + index + 1;
}
